import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { toast } from "sonner";
import { UserPlus, Trash2 } from "lucide-react";

const empty = { name: "", email: "", password: "", role: "staff" };

export const UserManagement = ({ currentUser }) => {
  const [users, setUsers] = useState([]);
  const [form, setForm] = useState(empty);

  const load = async () => setUsers((await api.get("/users")).data);
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return toast.error("E-posta ve şifre gerekli");
    try {
      await api.post("/users", form);
      toast.success("Kullanıcı eklendi");
      setForm(empty); load();
    } catch (err) { toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Eklenemedi"); }
  };

  const del = async (u) => {
    if (!window.confirm(`${u.email} silinsin mi?`)) return;
    try { await api.delete(`/users/${u.id}`); toast.success("Silindi"); load(); }
    catch (err) { toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Silinemedi"); }
  };

  return (
    <div className="space-y-4" data-testid="user-management">
      <Card className="p-6">
        <h3 className="font-bold mb-3">Yeni Kullanıcı</h3>
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
          <div><Label>Ad Soyad</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" data-testid="user-name-input" /></div>
          <div><Label>E-posta *</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1.5" data-testid="user-email-input" /></div>
          <div><Label>Şifre *</Label><Input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1.5" data-testid="user-password-input" /></div>
          <div>
            <Label>Rol</Label>
            <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="mt-1.5 flex h-10 w-full rounded-md border border-input bg-background px-3 text-sm" data-testid="user-role-select">
              <option value="staff">Personel</option>
              <option value="admin">Yönetici</option>
            </select>
          </div>
          <Button type="submit" data-testid="user-submit-btn"><UserPlus size={16} className="mr-1" /> Ekle</Button>
        </form>
      </Card>
      <Card className="p-4">
        <Table>
          <TableHeader><TableRow><TableHead>Ad</TableHead><TableHead>E-posta</TableHead><TableHead>Rol</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {users.map((u) => (
              <TableRow key={u.id} data-testid={`user-row-${u.id}`}>
                <TableCell className="font-semibold">{u.name}</TableCell>
                <TableCell>{u.email}</TableCell>
                <TableCell><span className="text-xs px-2 py-0.5 rounded bg-muted">{u.role === "admin" ? "Yönetici" : "Personel"}</span></TableCell>
                <TableCell className="text-right">
                  {u.id !== currentUser?.id && (
                    <Button variant="ghost" size="icon" onClick={() => del(u)} data-testid={`user-delete-${u.id}`}><Trash2 size={14} /></Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
};
